export default __webpack_public_path__ + "static/media/Skirt of the Cackling Marionette.4734d918.jpg";